export const KNOW_ERRORS = {
  quotation_not_pending: 'QUOTATIONS.ERRORS.QUOTATION_NOT_PENDING'
};
